/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ThreatExplorerWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("ThreatExplorerWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return ThreatExplorerWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<ThreatExplorerWidgetConfiguration>): ThreatExplorerWidgetConfiguration {
        let obj = Object.assign(new ThreatExplorerWidgetConfiguration(), model);
        ThreatExplorerWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ThreatExplorerWidgetConfiguration>): ThreatExplorerWidgetConfiguration {
        if (!model) return null;
        return ThreatExplorerWidgetConfiguration.newInstance(<ThreatExplorerWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ThreatExplorerWidgetConfiguration) {
        if (!obj) return;

        models.ThreatExplorerWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ThreatExplorerWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ThreatExplorerWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
